import React, {Fragment} from "react";
import {Link} from "react-router";

import Panel from "./Panel";
import Right from "./Right";
import FormItem from "./FormItem";

import langs from "./langs/appIndex";
import phpLangs from "./langs/phpIndex";

import {api} from "./baseFunctions";

import "./sheetPage.css";
export default class SheetPage extends React.Component {
    types = ["smileys_colored", "over-menu", "numberInput-country", "radio-gps", "textInput", "range", "addressInput", "radio", "select", "upload", "input", "numberInput", "multilineInput", "mapPicker", "assignTo", "message", "boolean", "randomizer", "valueChecker", "group", "points", "notNeeded", "smileys", "singlePageQuestions", "confirmSendReport"];
    functionalTypes = ["randomizer", "valueChecker", "group", "points", "notNeeded", "singlePageQuestions", "confirmSendReport", "over-menu"];

    state = {
        data: [],
        editing: false,
    };

    emptyQuestion = JSON.stringify({
        type: "",
        question: "",
        options: [],
        children: [],
        correct: "",
        isNew: true,
    });

    componentDidMount(){
        this.getData();
    }

    getData = () => {
        api("POST", {type: "getSheets"}, (data) => {
            console.log("Got sheets", data);
            if(!data.error)
            {
                const reverser = (question) => {
                    console.log(question.children);
                    question.children = question.children.map((d, i, arr) => arr[arr.length - i - 1]).map(question => reverser(question));
                    return question;
                };
                this.setState({
                    data: data.data/*.map(sheet => {
                        console.log(sheet);
                        return {
                            ...sheet,
                            questions: (sheet.questions || []).map(d => reverser(d))
                        };
                    })*/,
                });
            }
        }, this.props.auth);
    }

    updateNode(ref, node, key, value)
    {
        node[key] = value;
        this.setState({
            editing: {
                ...this.state.editing,
                questions: ref,
            }
        });
    }

    drawQuestions(node, child = 0, ref, parent = null, i = 0, length = 0)
    {
        const enabled = true;//node.isNew;// || (node.children || []).length !== 0;
        // console.log("Drawing", node, enabled, parent);
        return (<React.Fragment>
            <tr className="headings" key={JSON.stringify(node)}>
                <td className="column-title" style={{paddingLeft: ((child * 15) + 10) + "px"}}>
                    <select disabled={!enabled} defaultValue={node.type} onChange={(e) => this.updateNode(ref, node, "type", e.target.value)}>
                        <option></option>
                        {
                            this.types.map(type => <option value={type} key={type}>{type} [{this.functionalTypes.includes(type) ? "functional" : "input"}]</option>)
                        }
                    </select>
                </td>
                <td className="column-title">
                    {
                        !this.functionalTypes.includes(node.type) &&
                            <input type="text" defaultValue={node.question || ""} onBlur={(e) => this.updateNode(ref, node, "question", e.target.value)} disabled={!enabled} />
                    }
                    
                </td>
                <td className="column-title">
                    {
                        !this.functionalTypes.includes(node.type) ?
                            <input defaultValue={node.options.join(",")} onBlur={(e) => this.updateNode(ref, node, "options", e.target.value.split(","))} disabled={!enabled}/>
                            :
                            <input defaultValue={node.correct} onBlur={(e) => this.updateNode(ref, node, "correct", e.target.value)} disabled={!enabled}/>
                    }
                    
                    {/* <table className="table table-striped jambo_table bulk_action">
                        <thead>
                            <tr className="headings">
                            <th className="column-title">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                options
                            }
                        </tbody>
                    </table> */}
                </td>
                {
                    [...this.functionalTypes, "select", "radio", "radio-gps", "numberInput-country"].includes(node.type) ? 
                        <td className="column-title cursor" onClick={() => {
                            if(node)
                            {
                                node.children.push(JSON.parse(this.emptyQuestion));
                                this.setState({
                                    editing:  {
                                        ...this.state.editing,
                                        questions: ref,
                                    }
                                });
                            }
                        }}>+</td>
                    : <td/>
                }
                {
                    i > 0 ? <td className="column-title cursor" onClick={() => {
                        if(node)
                        {
                            if(parent)
                            {
                                parent.children = [
                                    ...parent.children.filter((_, childI) => childI < i - 1),
                                    node,
                                    ...parent.children.filter((_, childI) => (childI > i) || (childI == i - 1)),
                                ];

                                this.setState({
                                    questions:  {
                                        ...this.state.editing,
                                        children: ref,
                                    }
                                });
                            }else{
                                this.setState({
                                    editing:  {
                                        ...this.state.editing,
                                        questions: [
                                            ...ref.filter((_, childI) => childI < i - 1),
                                            node,
                                            ...ref.filter((_, childI) => (childI > i) || (childI == i - 1)),
                                        ],
                                    }
                                });
                            }
                        }
                    }}>
                                &#8593;
                            </td>
                    : <td/>
                }
                {
                    (length - 1) !== i ? <td className="column-title cursor" onClick={() => {
                        if(node)
                        {
                            if(parent)
                            {
                                parent.children = [
                                    ...parent.children.filter((_, childI) => childI < i || (childI == i + 1)),
                                    node,
                                    ...parent.children.filter((_, childI) => (childI > i + 1)),
                                ];

                                this.setState({
                                    editing:  {
                                        ...this.state.editing,
                                        questions: ref,
                                    }
                                });
                            }else{
                                this.setState({
                                    editing:  {
                                        ...this.state.editing,
                                        questions: [
                                            ...ref.filter((_, childI) => childI < i || (childI == i + 1)),
                                            node,
                                            ...ref.filter((_, childI) => (childI > i + 1)),
                                        ],
                                    }
                                });
                            }
                        }
                    }}>
                                &#8595;
                            </td>
                    : <td/>
                }
                <td className="column-title cursor" onClick={() => {
                    console.log("Remove", ref, i, ref.filter((_, key) => key !== i));
                    if(parent)
                    {
                        parent.children = parent.children.filter((_, key) => key !== i);
                        this.setState({
                            editing:  {
                                ...this.state.editing,
                                questions: ref,
                            }
                        });
                    }else{
                        this.setState({
                            editing:  {
                                ...this.state.editing,
                                questions: ref.filter((_, key) => key !== i),
                            }
                        });
                    }
                    
                    // if(node)
                    // {
                    //     node.children.push(JSON.parse(this.emptyQuestion));
                    // }
                }}>Slet</td>
                <td>{node.questionID}</td>
                
            </tr>
            {
                (node.children || []).map((childNode, i, arr) => this.drawQuestions(childNode, (child + 1), ref, node, i, arr.length))
            }
        </React.Fragment>);
    }

    typeDesc = {
        "textInput": "Et tekstfelt.",
        "input": "Et tekstfelt.",
        "range": "Tilføjer knapper mellem et interval. I options skrives intervallet sepereret med komma. (F.eks 1,5 viil give knapper fra 1 til 5)",
        "addressInput": "Et addresse søgefelt. (Kræver internet)",
        "radio": "Mulighed for at vælge ét element af en liste. Første barn er overkategorien, dens børn er valgmulighederne på listen.",
        "select": "Mulighed for at vælge flere elementer af en liste. Første barn er overkategorien, dens børn er valgmulighederne på listen.",
        "upload": "Giver mulighed for at uploade billeder fra kamera eller kamerarulle. (Kræver internet)",
        "numberInput": "Et tekstfelt som kun godtager numre.",
        "multilineInput": "Et tekstfelt hvor der kan skrives flere linjer.",
        "mapPicker": "Kort hvor der kan trykkes for at sætte en pin.",
        "boolean": "Spørgsmål med tekst-muligheder. Valgmuligheder separeres med komma.",
        "assignTo": "Tildeler besvarelsen til den valgte afdeling. Den tager automatisk alle afdelinger i firmaet.",
        "message": "Viser en boks med teksten defineret i question.",
        "smileys_colored": 'Fungere nøjagtig som "smileys", men smileys bliver automatisk farvet udfra firmaets farver.',
        "smileys": "Mulighed for at vælge mellem grøn, gul og rød smiley",
        "numberInput-country": "Nummer input, med valgmuligheder efter. Hvert barn er en valgmulighed, dens question = væriden, option er dens timezone (Copenhagen, America etc).",
        "over-menu": "Options = Titlen på hver knap | Børnende af den bliver vist når man trykker på knappen", 
        "radio-gps": "Question = Titlen på knappen, Første brn = Overskrift, Børn derunder = (Question = titel, Options = LAT,LONG)",

        "randomizer": "Shuffler alle komponenter som er et barn af den.",
        "valueChecker": "Checker værdien af det første barn, er det ikke det som er skrevet i `Correct` så vises resten af børnene.",
        "notNeeded": "Børnene af dette element behøver ikke blive udfyldt.",
        "points": "Checker værdien af det første barn, er det ikke det som er skrevet i `Correct` så vises resten af børnene. Hvis børnene er `radio` ganges numrene af de valgte elementer sammen. (Hvis Mellem og venstre vælges i listerne 'lav, mellem, høj' og 'op, højre, venstre'. Vil det give 1*2 = 2)",
        "group": "Gruppere en gruppe af komponenter til ét.",
        "singlePageQuestions": "Kun et barn bliver vist af gangen",
        "confirmSendReport": "Hvis barnet svarer korrekt bliver rapporten indsendt",

    };
    render(){
        const LANG = phpLangs[this.props.lang];
        const APP_LANG = langs[this.props.lang];
        const editing = this.state.editing;
        console.log("Editing", editing.questions);
        return (<Right title="Skemaer" token={this.props.auth} lang={this.props.lang}>
            {
                this.state.editing && <Panel title={`Kopi af "${editing.name}"`}>
                    <FormItem name="Dokumentation">
                        {
                            this.types.map(type => <div className="doc">
                                <b>{type}</b><br/>
                                {
                                    this.typeDesc[type] || "No documentation found!"
                                }
                            </div>)
                        }
                    </FormItem>
                    <FormItem name="Navn">
                        <input type="text" className="form-control col-md-7 col-xs-12" required="" defaultValue={editing.name} onBlur={(e) => this.setState({
                            editing: {
                                ...this.state.editing,
                                name: e.target.value,
                            }
                        })}/>
                    </FormItem>
                    <FormItem name="Brug sags-styring?">
                        <input type="checkbox" className="form-control col-md-7 col-xs-12" defaultChecked={editing.hasCase === 1} onClick={e => this.setState({
                            editing: {
                                ...this.state.editing,
                                hasCase: e.target.checked ? 1 : 0,
                            },
                        })}/>
                    </FormItem>
                    <table className="table table-striped jambo_table bulk_action">
                        <thead>
                            <tr className="headings">
                                <th className="column-title">Type</th>
                                <th className="column-title">Question</th>
                                <th className="column-title">Options / Correct</th>
                                <th className="column-title cursor" onClick={() => this.setState({
                                    editing: {
                                        ...this.state.editing,
                                        questions: [
                                            JSON.parse(this.emptyQuestion),
                                            ...this.state.editing.questions,
                                        ]
                                    }
                                })}>+</th>
                                <th className="column-title"></th>
                                <th className="column-title"></th>
                                <th className="column-title"></th>
                                <th className="column-title">ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                [...editing.questions].map((question, key, arr) => this.drawQuestions(question, 0, arr, null, key, arr.length))
                            }
                            
                        </tbody>
                    </table>

                    <button onClick={async () => {
                        console.log("Save data", this.state.editing);
                        // return;
                        api("POST", {type: "saveSheetData", data: this.state.editing}, (resp) => {
                            if(!resp.error)
                            {
                                this.setState({
                                    editing: false,
                                });
                                this.getData();
                            }
                        }, this.props.auth)
                    }}>
                        Gem som nyt ark!
                    </button>
                </Panel>
            }
            <Panel title="Oversigt">
                <button onClick={() => this.setState({
                    editing: {
                        hasCase: 0,
                        name: "Nyt ark",
                        questions: [],
                    }
                })}>Opret nyt</button>
                <table className="table table-striped jambo_table bulk_action" id="ras" style={this.state.data.length === 0 ? {display: "none"} : {}}>
                    <thead>
                        <tr className="headings">
                        <th className="column-title">{LANG.ID}</th>
                        <th className="column-title">{LANG.NAME}</th>
                        <th className="column-title"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.data.map((sheet, key) => (<tr className="headings" key={"user" + key}>
                            <td className="column-title">{sheet.id}</td>
                            <td className="column-title">
                                    {sheet.name}
                            </td>
                            <td className="column-title">
                                <Link to={"/sheets"} onClick={() => this.setState({editing: sheet})}>Lav en kopi</Link>
                            </td>
                          </tr>))
                        }
                        
                    </tbody>
                </table>
        </Panel>

        </Right>);
    }
}


// WEBPACK FOOTER //
// ./src/components/SheetPage.js